import type { CompanyRegistryCheckResult } from '@ballerine/digital-footprint-schemas';
import { Database } from 'lucide-react';
import type { FunctionComponent } from 'react';

import { ReportWrapper } from '../../report-shared/components';
import { RegistryData } from '../components/RegistryData';
import { OpenCorporatesIcon } from '@/components/atoms/Icons/OpenCorporatesIcon';

type RegistryDataSectionProps = {
  registryData?: CompanyRegistryCheckResult | null;
};

export const RegistryDataSection: FunctionComponent<RegistryDataSectionProps> = ({
  registryData,
}) => {
  return (
    <ReportWrapper
      title={
        <div className="flex items-center gap-2">
          <OpenCorporatesIcon className="h-6 w-6" />
          <span>Registry Data</span>
        </div>
      }
      Icon={Database}
      tooltip="Official company registry information from company registries."
      showTooltip={false}
    >
      <RegistryData registryData={registryData} />
    </ReportWrapper>
  );
};
